import axios from 'axios'
import { formatDateForFilter } from '../utils/date.js'

export const fetchMessages = async (accessToken, params) => {
  return axios.get(`${process.env.API_URL}/mail/collection`, {
    params: {
      ...params,
      dateTo: params.dateTo ? formatDateForFilter(params.dateTo) : null,
      dateFrom: params.dateFrom ? formatDateForFilter(params.dateFrom) : null,
      hasAttachments: params.hasAttachments ? true : null,
      groupBy: 'outlook-date',
      limit: 5
    },
    headers: {
      'X-Api-Key': process.env.API_KEY,
      Authorization: `Bearer ${accessToken}`
    }
  })
}
